import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { map, Observable, tap } from 'rxjs';
import { environment } from '../environments/environment';
import { TokenService } from './token.service';

export interface AuthRequest {
    email: string;
    password: string;
    language: string;
}
export interface ActivateRequest {
    code: string;
    email: string;
    password: string;
}

export interface TokenResponse {
    token: string;
}
export interface ForgotPasswordRequest {
    email: string;
}

export interface ResetPasswordRequest {
    token: string;
    password: string;
}
@Injectable({
    providedIn: 'root'
})
export class AuthService {


    constructor(private http: HttpClient, private tokenService: TokenService) { }


    public register(request: AuthRequest): Observable<TokenResponse> {
        this.tokenService.clear();
        return this.http.post<TokenResponse>(environment.apiUrl + "/v1/auth/register", request).pipe(
            map((response: any) => {
                this.tokenService.save(response.token);
                return response;
            })
        )
    }

    public activate(request: ActivateRequest): Observable<TokenResponse> {
        this.tokenService.clear();
        return this.http.post<TokenResponse>(environment.apiUrl + "/v1/auth/activate", request).pipe(
            map((response: any) => {
                this.tokenService.save(response.token);
                return response;
            })
        )
    }

    public login(request: AuthRequest): Observable<TokenResponse> {
        this.tokenService.clear();
        return this.http.post<TokenResponse>(environment.apiUrl + "/v1/auth/login", request).pipe(
            tap((response: TokenResponse) => {
                if (response && response.token) {
                    this.tokenService.save(response.token);
                }
            }),
            map((response: TokenResponse) => response)
        )
    }

    public logout() {
        this.tokenService.clear();
    }

    public isAuthenticated(): boolean {
        return this.tokenService.getToken().isValid();
    }


    public isAdmin(): boolean {
        return this.hasRole(["admin"]);
    }

    public hasRole(permissions: string[]): boolean {
        const token = this.tokenService.getToken();
        return token.isValid() &&
            token.user.roles &&
            permissions.some(role => token.user.roles.includes(role));
    }

    public requestResetPassword(request: ForgotPasswordRequest): Observable<any> {
        this.tokenService.clear();
        return this.http.post<any>(environment.apiUrl + "/v1/auth/request-reset-password", request);
    }

    public enableResetPasswordToken(token: string): Observable<any> {
        this.tokenService.clear();
        return this.http.get<any>(environment.apiUrl + "/v1/auth/reset-password?token=" + token);
    }

    public resetPassword(request: ResetPasswordRequest): Observable<any> {
        this.tokenService.clear();
        return this.http.post<any>(environment.apiUrl + "/v1/auth/reset-password", request);
    }
    
}